import helpers from './helpers';
import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

start15SecTimeout();

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

helpers.$document
	.on('analytics-card-show', (e, name) => {
		ga('send', 'event', 'cards', 'show', name, {nonInteraction: true});
	})
	.on('click', '[data-social]', (e) => {
		const social = e.currentTarget.dataset.social;

		if (e.currentTarget.classList.contains('card__button')) {
			ga('send', 'event', 'share', 'cards share', social);
		} else {
			ga('send', 'event', 'share', 'project share', social);
		}
	});

$('.header__logo').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});
